module.exports = __webpack_public_path__ + "static/img/图标.30f9d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/图标.jpg
// module id = kpiV
// module chunks = 1